import { getTodaysDate } from "@/lib/dayjs/get-todays-date";
import { CurrencyType, SaleTypeForTerm, VoucherLimitType } from "@/lib/gql/__generated__/graphql";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type * as Type from "../type";

type InputModel = Type.FormModel["InputModel"];
type Props = {
	hotelID: string;
	voucherID: string;
};

export const DEFAULT_PRODUCT_VOUCHER_INPUT_MODEL = ({ hotelID, voucherID }: Props) => {
	const defaultPriceObject = {
		amount: 0,
		currencyType: CurrencyType.Jpy,
	};

	const todaysDate = getTodaysDate();

	const inputModel: InputModel = {
		hotelID,
		voucherID,

		inSale: false,

		name: "",
		description: "",

		mainKeyVisual: DUMMY_IMAGE.s3Object,

		voucherPrice: defaultPriceObject,
		sellingPrice: defaultPriceObject,

		saleTypeForTerm: SaleTypeForTerm.Always,
		saleStart: null,
		saleEnd: null,

		voucherLimitType: VoucherLimitType.StayDate,

		cinStart: todaysDate,
		cinEnd: todaysDate,

		intervalPrepDates: 30,
		soldNumTotal: 0,
	} satisfies InputModel;

	return inputModel;
};
